import { ApprovalRules } from '../types';
import { UnreachableI18nCaseError } from './i18nUtils';
export const getAvailableApprovalRules = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'BLOG_POST':
    case 'DEAL':
    case 'KNOWLEDGE_ARTICLE':
    case 'QUOTE':
    case 'SOCIAL_BROADCAST':
      return [ApprovalRules.NON_SEQUENTIAL, ApprovalRules.ANY_CAN_APPROVE];
    case 'CONNECTED_APP':
      return [ApprovalRules.ANY_CAN_APPROVE];
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
};